import React, { Fragment } from "react";
import { connect } from "react-redux";
import HomeItem from "./HomeItem";
import UserInfo from "./UserInfo";
import Spinner from "../layout/Spinner";
import { Box, Paper, Typography } from "@mui/material";

const SearchUser = ({
  home,
  user,
  loading,
}) => {
  if (loading || user == null) {
    return <Spinner />;
  }

  const homeData = home?.home;

  return (
    <Fragment>
      <UserInfo user={user} />

      {homeData === null ? (
        <Spinner />
      ) : (
        <Box sx={{ mt: 2, display: "grid", gap: 2 }}>
          <Paper elevation={2} sx={{ p: 2, borderRadius: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.5 }}>
              Primary Home ID(s)
            </Typography>
            <HomeItem home={home} homeData={homeData?.primaryUserHomeIds} />
          </Paper>

          <Paper elevation={2} sx={{ p: 2, borderRadius: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.5 }}>
              Secondary Home ID(s)
            </Typography>
            <HomeItem home={home} homeData={homeData?.secondaryUserHomeIds} />
          </Paper>
        </Box>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  home: state.home,
});

export default connect(mapStateToProps)(SearchUser);
